import { useEffect, useRef, useState } from 'react';
import { toWebpSrc } from '../../utils/imageLoad';

function ProductCardMedia({ src, alt = '', index = 0 }) {
  const imgRef = useRef(null);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    if (imgRef.current?.complete) {
      setLoaded(true);
    }
  }, [src]);

  if (!src) {
    return null;
  }

  const webpSrc = toWebpSrc(src);
  const loading = index < 6 ? 'eager' : 'lazy';
  const fetchPriority = index < 3 ? 'high' : 'auto';

  return (
    <div className="product-card-media" aria-hidden="true">
      <picture>
        <source srcSet={webpSrc} type="image/webp" />
        <img
          ref={imgRef}
          src={src}
          alt={alt}
          loading={loading}
          fetchPriority={fetchPriority}
          decoding="async"
          className={loaded ? 'is-loaded' : ''}
          onLoad={() => setLoaded(true)}
        />
      </picture>
    </div>
  );
}

export default ProductCardMedia;
